/**
 * asyncRoutes dms路由
 * the routes that need to be dynamically loaded based on user permission_uri
 */

import Layout from '@/layout'

export const dms = [
  {
    path: '/dms/home',
    component: Layout,
    redirect: '/dms/home/dashboard',
    name: 'Home',
    alwaysShow: true,
    meta: {
      title: '首页',
      icon: 'home',
      permission_uri: '/dms/home'
    },
    children: [
      // {
      //   path: 'map',
      //   name: 'HomeMap',
      //   component: () => import('@/views/home/map'),
      //   meta: {
      //     title: '数据地图',
      //     icon: 'map',
      //     permission_uri: '/home/map'
      //   }
      // },
      {
        path: 'dashboard',
        name: 'HomeDashboard',
        component: () => import('@/views/dms/home/dashboard'),
        meta: {
          title: '数据看板',
          icon: 'dashboard',
          permission_uri: '/dms/home/dashboard'
        }
      }, {
        path: 'bi',
        meta: {
          title: 'BI',
          icon: 'overview',
          permission_uri: '/dms/home/bi'
        }
      }]
  },
  {
    path: '/dms/market',
    component: Layout,
    redirect: '/dms/market/overview',
    name: 'Market',
    alwaysShow: true,
    meta: {
      title: '投放数据分析',
      icon: 'el-icon-data-analysis',
      elementuiIcon: true,
      permission_uri: '/dms/market'
    },
    children: [{
      path: 'overview',
      name: 'MarketOverview',
      component: () => import('@/views/dms/market/overview'),
      meta: {
        title: '投放总览',
        icon: 'overview',
        permission_uri: '/dms/market/overview'
      }
    }, {
      path: 'hour-overview',
      name: 'MarketHourOverview',
      component: () => import('@/views/dms/market/hourOverview'),
      meta: {
        title: '分时总览',
        icon: 'kpi',
        permission_uri: '/dms/market/hour-overview'
      }
    }, {
      path: 'simple-hour-overview',
      name: 'MarketSimpleHourOverview',
      component: () => import('@/views/dms/market/simpleHourOverview'),
      meta: {
        title: '分时数据',
        icon: 'dashboard',
        permission_uri: '/dms/market/simple-hour-overview'
      }
    }, {
      path: 'retain',
      name: 'MarketRetain',
      component: () => import('@/views/dms/market/retain'),
      meta: {
        title: '留存情况',
        icon: 'retain',
        permission_uri: '/dms/market/retain'
      }
    }, {
      path: 'action-retain',
      name: 'ActionRetain',
      component: () => import('@/views/dms/market/actionRetain'),
      meta: {
        title: '激活留存',
        icon: 'retain',
        permission_uri: '/dms/market/action-retain'
      }
    }, {
      path: 'payment',
      name: 'MarketPayment',
      component: () => import('@/views/dms/market/payment'),
      meta: {
        title: '付费情况',
        icon: 'payment',
        permission_uri: '/dms/market/payment'
      }
    },
    {
      path: 'payment-month',
      name: 'MarketPaymentMonth',
      component: () => import('@/views/dms/market/paymentMonth'),
      meta: {
        title: '付费情况(自然月)',
        icon: 'payment',
        permission_uri: '/dms/market/payment-month'
      }
    }, {
      path: 'pay-estimate',
      name: 'PaymentEstimate',
      component: () => import('@/views/dms/market/payEstimate'),
      meta: {
        title: '付费预估',
        icon: 'payment',
        permission_uri: '/dms/market/pay-estimate'
      }
    },
    {
      path: 'pay-estimate-month',
      name: 'PaymentEstimateMonth',
      component: () => import('@/views/dms/market/payEstimateMonth'),
      meta: {
        title: '付费预估(自然月)',
        icon: 'payment',
        permission_uri: '/dms/market/pay-estimate-month'
      }
    },
    {
      path: 'optimization',
      name: 'MarketOptimization',
      component: () => import('@/views/dms/market/optimization'),
      meta: {
        title: '投放调优',
        icon: 'optimization',
        permission_uri: '/dms/market/optimization'
      }
    }, {
      path: 'flow-estimate',
      name: 'FlowEstimate',
      component: () => import('@/views/dms/market/flowEstimate'),
      meta: {
        title: '流水预估',
        icon: 'database',
        permission_uri: '/dms/market/flow-estimate'
      }
    }, {
      path: 'recharge-rank',
      name: 'MarketRechargeRank',
      component: () => import('@/views/dms/market/rechargeRank'),
      meta: {
        title: '充值排行榜',
        icon: 'comparison',
        permission_uri: '/dms/market/recharge-rank'
      }
    }, {
      path: 'abnormal-click',
      name: 'AbnormalClick',
      component: () => import('@/views/dms/market/abnormalClick'),
      meta: {
        title: '渠道异常点击',
        icon: 'abnormal',
        permission_uri: '/dms/market/abnormal-click'
      }
    }, {
      path: 'team-config',
      name: 'TeamConfig',
      component: () => import('@/views/dms/market/teamConfig'),
      meta: {
        title: '团队数据',
        icon: 'payment',
        permission_uri: '/dms/market/team-config'
      }
    }]
  },
  {
    path: '/dms/operation',
    component: Layout,
    redirect: '/dms/operation/overview',
    name: 'Operation',
    alwaysShow: true,
    meta: {
      title: '运营数据分析',
      icon: 'el-icon-data-analysis',
      elementuiIcon: true,
      permission_uri: '/dms/operation'
    },
    children: [{
      path: 'overview',
      name: 'OperationOverview',
      component: () => import('@/views/dms/operation/overview'),
      meta: {
        title: '运营总览',
        icon: 'overview',
        permission_uri: '/dms/operation/overview'
      }
    }, {
      path: 'simple-hour-overview',
      name: 'OperationSimpleHourOverview',
      component: () => import('@/views/dms/operation/simpleHourOverview'),
      meta: {
        title: '分时数据',
        icon: 'dashboard',
        permission_uri: '/dms/operation/simple-hour-overview'
      }
    }, {
      path: 'hour-overview',
      name: 'OperationHourOverview',
      component: () => import('@/views/dms/operation/hourOverview'),
      meta: {
        title: '分时总览',
        icon: 'kpi',
        permission_uri: '/dms/operation/hour-overview'
      }
    }, {
      path: 'retain',
      name: 'OperationRetain',
      component: () => import('@/views/dms/operation/retain'),
      meta: {
        title: '留存情况',
        icon: 'retain',
        permission_uri: '/dms/operation/retain'
      }
    }, {
      path: 'action-retain',
      name: 'OperationActionRetain',
      component: () => import('@/views/dms/operation/actionRetain'),
      meta: {
        title: '激活留存',
        icon: 'retain',
        permission_uri: '/dms/operation/action-retain'
      }
    }, {
      path: 'payment',
      name: 'OperationPayment',
      component: () => import('@/views/dms/operation/payment'),
      meta: {
        title: '付费情况',
        icon: 'payment',
        permission_uri: '/dms/operation/payment'
      }
    }, {
      path: 'game',
      name: 'OperationGame',
      component: () => import('@/views/dms/operation/game'),
      meta: {
        title: '游戏生态',
        icon: 'game',
        permission_uri: '/dms/operation/game'
      }
    }, {
      path: 'comparison',
      name: 'OperationComparison',
      component: () => import('@/views/dms/operation/comparison'),
      meta: {
        title: '数据对比',
        icon: 'comparison',
        permission_uri: '/dms/operation/comparison'
      }
    }, {
      path: 'wastage',
      name: 'Wastage',
      component: () => import('@/views/dms/operation/wastage'),
      meta: {
        title: '流失情况',
        icon: 'log',
        permission_uri: '/dms/operation/wastage'
      }
    }, {
      path: 'server-data-overview',
      name: 'ServerDataOverview',
      component: () => import('@/views/dms/operation/serverDataOverview'),
      meta: {
        title: '区服数据概况',
        icon: 'overview',
        permission_uri: '/dms/operation/server-data-overview'
      }
    }, {
      path: 'game-online',
      name: 'GameOnline',
      component: () => import('@/views/dms/operation/gameOnline'),
      meta: {
        title: '游戏在线情况',
        icon: 'kpi',
        permission_uri: '/dms/operation/game-online'
      }
    }, {
      path: 'recharge-rank',
      name: 'RechargeRank',
      component: () => import('@/views/dms/operation/rechargeRank'),
      meta: {
        title: '充值排行榜',
        icon: 'comparison',
        permission_uri: '/dms/operation/recharge-rank'
      }
    }, {
      path: 'front-end-conversion',
      name: 'FrontEndConversion',
      component: () => import('@/views/dms/operation/frontEndConversion'),
      meta: {
        title: '前端转化',
        icon: 'comparison',
        permission_uri: '/dms/operation/front-end-conversion'
      }
    }, {
      path: 'order-conversion',
      name: 'OrderConversion',
      component: () => import('@/views/dms/operation/orderConversion'),
      meta: {
        title: '订单转化',
        icon: 'comparison',
        permission_uri: '/dms/operation/order-conversion'
      }
    }, {
      path: 'account-bind',
      name: 'AccountBind',
      component: () => import('@/views/dms/operation/accountBind'),
      meta: {
        title: '账号绑定情况',
        icon: 'database',
        permission_uri: '/dms/operation/account-bind'
      }
    }, {
      path: 'server-ecology',
      name: 'ServerEcology',
      component: () => import('@/views/dms/operation/serverEcology'),
      meta: {
        title: '区服生态',
        icon: 'database',
        permission_uri: '/dms/operation/server-ecology'
      }
    }, {
      path: 'website-recharge',
      name: 'WebsiteRecharge',
      component: () => import('@/views/dms/operation/websiteRecharge'),
      meta: {
        title: '官网充值',
        icon: 'database',
        permission_uri: '/dms/operation/website-recharge'
      }
    }, {
      path: 'product-score',
      name: 'ProductScore',
      component: () => import('@/views/dms/operation/productScore/'),
      meta: {
        title: '产品评级',
        icon: 'prosuct-score',
        permission_uri: '/dms/operation/product-score'
      }
    }, {
      path: 'internal-source-manage',
      name: 'InternalSourceManage',
      component: () => import('@/views/dms/operation/internalSourceManage'),
      meta: {
        title: '内部账号资源管理',
        icon: 'database',
        permission_uri: '/dms/operation/internal-source-manage'
      }
    }, {
      path: 'data-overview',
      name: 'DataOverview',
      component: () => import('@/views/dms/operation/dataOverview'),
      meta: {
        title: '数据月活统计',
        icon: 'overview',
        permission_uri: '/dms/operation/data-overview'
      }
    }, {
      path: 'user-profile',
      name: 'UserProfile',
      component: () => import('@/views/dms/operation/userProfile'),
      meta: {
        title: '用户画像',
        icon: 'overview',
        permission_uri: '/dms/operation/user-profile'
      }
    }]
  },
  {
    path: '/dms/dmp',
    component: Layout,
    redirect: '/dms/dmp/device',
    alwaysShow: true,
    name: 'DMP',
    meta: {
      title: 'DMP 工具',
      icon: 'dmp',
      permission_uri: '/dms/dmp'
    },
    children: [{
      path: 'device',
      name: 'DMPDevice',
      component: () => import('@/views/dms/dmp/device'),
      meta: {
        title: '设备导出',
        icon: 'device',
        permission_uri: '/dms/dmp/device'
      }
    }, {
      path: 'download-history',
      name: 'DMPDownloadHistory',
      component: () => import('@/views/dms/dmp/downloadHistory'),
      meta: {
        title: '下载历史',
        icon: 'log',
        permission_uri: '/dms/dmp/download-history'
      }
    }, {
      path: 'audience',
      name: 'DMPAudience',
      component: () => import('@/views/dms/dmp/audience'),
      meta: {
        title: '人群推送',
        icon: 'audience',
        permission_uri: '/dms/dmp/audience'
      }
    }, {
      path: 'file-list',
      name: 'FileList',
      component: () => import('@/views/dms/dmp/fileList'),
      meta: {
        title: '文件列表',
        icon: 'form',
        permission_uri: '/dms/dmp/file-list'
      }
    }]
  },
  {
    path: '/dms/individuation',
    component: Layout,
    redirect: '/dms/individuation/overview',
    name: 'Individuation',
    alwaysShow: true,
    meta: {
      title: '个性化管理',
      icon: 'optimization',
      permission_uri: '/dms/individuation'
    },
    children: [
      // {
      //   path: 'dashboard',
      //   name: 'IndividuationDashboard',
      //   component: () => import('@/views/individuation/dashboard'),
      //   meta: {
      //     title: '看板展示',
      //     icon: 'dashboard',
      //     permission_uri: '/individuation/dashboard'
      //   }
      // },
      {
        path: 'kpi',
        name: 'IndividuationKPI',
        component: () => import('@/views/dms/individuation/kpi'),
        meta: {
          title: 'KPI设置',
          icon: 'kpi',
          permission_uri: '/dms/individuation/kpi'
        }
      }, {
        path: 'feedback',
        name: 'IndividuationFeedback',
        component: () => import('@/views/dms/individuation/feedback'),
        meta: {
          title: '用户反馈',
          icon: 'feedback',
          permission_uri: '/dms/individuation/feedback'
        }
      }, {
        path: 'notice-message',
        name: 'PushManager',
        component: () => import('@/views/dms/individuation/noticeMessage'),
        meta: {
          title: '推送管理',
          icon: 'log',
          permission_uri: '/dms/individuation/notice-message'
        }
      }, {
        path: 'game-warning',
        name: 'GameWarning',
        component: () => import('@/views/dms/individuation/gameWarning'),
        meta: {
          title: '游戏警报',
          icon: 'device',
          permission_uri: '/dms/individuation/game-warning'
        }
      }]
  },
  // {
  //   path: '/dms/fm',
  //   component: Layout,
  //   redirect: '/dms/fm/tax-write',
  //   name: 'FM',
  //   alwaysShow: true,
  //   meta: {
  //     title: '财务管理',
  //     icon: 'finance',
  //     permission_uri: '/dms/fm'
  //   },
  //   children: [{
  //     path: 'tax-write',
  //     name: 'TaxWrite',
  //     component: () => import('@/views/dms/fm/taxWrite'),
  //     meta: {
  //       title: '税务录入',
  //       icon: 'comparison',
  //       permission_uri: '/dms/fm/tax-write'
  //     }
  //   },
  //   {
  //     path: 'finance-account',
  //     name: 'FinanceAccount',
  //     component: () => import('@/views/dms/fm/financeAccount'),
  //     meta: {
  //       title: '财务台账',
  //       icon: 'comparison',
  //       permission_uri: '/dms/fm/finance-account'
  //     }
  //   },
  //   {
  //     path: 'rebate-input',
  //     name: 'RebateInput',
  //     component: () => import('@/views/dms/fm/rebateInput'),
  //     meta: {
  //       title: '台账信息录入',
  //       icon: 'comparison',
  //       permission_uri: '/dms/fm/rebate-input'
  //     }
  //   }]
  // },
  {
    path: '/dms/twdblog',
    component: Layout,
    redirect: '/dms/twdblog/errorlog',
    name: 'TWDBLog',
    alwaysShow: true,
    meta: {
      title: '数据管理',
      icon: 'database',
      permission_uri: '/dms/twdblog'
    },
    children: [{
      path: 'data-query',
      name: 'DataQuery',
      component: () => import('@/views/dms/twdblog/dataQuery'),
      meta: {
        title: '数据查询',
        icon: 'el-icon-search',
        elementuiIcon: true,
        permission_uri: '/dms/twdblog/data-query'
      }
    },
    {
      path: 'data-config',
      name: 'DataConfig',
      component: () => import('@/views/dms/twdblog/dataConfig'),
      meta: {
        title: '数据配置',
        icon: 'el-icon-setting',
        elementuiIcon: true,
        permission_uri: '/dms/twdblog/data-config'
      }
    },
    {
      path: 'early-warning-standard',
      name: 'EarlyWarningStandard',
      component: () => import('@/views/dms/twdblog/earlyWarningStandard'),
      meta: {
        title: '预警标准',
        icon: 'el-icon-timer',
        elementuiIcon: true,
        permission_uri: '/dms/twdblog/early-warning-standard'
      }
    }, {
      path: 'operation-profit',
      name: 'OperationProfit',
      component: () => import('@/views/dms/twdblog/operationProfit'),
      meta: {
        title: '运营利润',
        icon: 'dashboard',
        permission_uri: '/dms/twdblog/operation-profit'
      }
    }, {
      path: 'ad-inspire-cost',
      name: 'AdInspireCost',
      component: () => import('@/views/dms/twdblog/adInspireCost'),
      meta: {
        title: '激励广告报表',
        icon: 'dashboard',
        permission_uri: '/dms/twdblog/ad-inspire-cost'
      }
    }, {
      path: 'cost-input',
      name: 'CostInput',
      component: () => import('@/views/dms/twdblog/costInput'),
      meta: {
        title: '消耗录入',
        icon: 'comparison',
        permission_uri: '/dms/twdblog/cost-input'
      }
    }, {
      path: 'audit-overview',
      name: 'AuditOverview',
      component: () => import('@/views/dms/twdblog/auditOverview'),
      meta: {
        title: '审计总览',
        icon: 'comparison',
        permission_uri: '/dms/twdblog/audit-overview'
      }
    }, {
      path: 'agent-rebate',
      name: 'AgentRebate',
      component: () => import('@/views/dms/twdblog/rebateCost'),
      meta: {
        title: '渠道返点',
        icon: 'agent-rebate',
        permission_uri: '/dms/twdblog/agent-rebate'
      }
    }, {
      path: 'user-group',
      name: 'UserGroup',
      component: () => import('@/views/dms/twdblog/userGroup'),
      meta: {
        title: '用户分群配置',
        icon: 'user-grouping',
        permission_uri: '/dms/twdblog/user-group'
      }
    }, {
      path: 'interface-person-group',
      name: 'InterfacePersonGroup',
      component: () => import('@/views/dms/twdblog/interfacePersonGroup'),
      meta: {
        title: '对接人分组',
        icon: 'retain',
        permission_uri: '/dms/twdblog/interface-person-group'
      }
    }, {
      // zx后台功能
      path: 'share-cost',
      name: 'ShareCost',
      component: () => import('@/views/dms/twdblog/shareCost'),
      meta: {
        title: '消耗分摊',
        icon: 'retain',
        permission_uri: '/dms/twdblog/share-cost'
      }
    }, {
      path: 'profit-statement',
      name: 'ProfitStatement',
      component: () => import('@/views/dms/twdblog/profitStatement'),
      meta: {
        title: '产品利润',
        icon: 'dashboard',
        permission_uri: '/dms/twdblog/profit-statement'
      }
    }, {
      path: 'overseas-divide',
      name: 'OverseasDivide',
      component: () => import('@/views/dms/twdblog/overseasDivide'),
      meta: {
        title: '海外分成',
        icon: 'dashboard',
        permission_uri: '/dms/twdblog/overseas-divide'
      }
    }]
  },
  {
    path: '/dms/data-config',
    component: Layout,
    redirect: '/dms/data-config/agent-group-type',
    name: 'DmsDataConfig',
    alwaysShow: true,
    meta: {
      title: '配置管理',
      icon: 'el-icon-setting',
      elementuiIcon: true,
      permission_uri: '/dms/data-config'
    },
    children: [{
      path: 'agent-group-type',
      name: 'AgentGroupType',
      component: () => import('@/views/dms/data-config/agentGroupType'),
      meta: {
        title: '渠道组类型',
        icon: 'el-icon-s-grid',
        elementuiIcon: true,
        permission_uri: '/dms/data-config/agent-group-type'
      }
    }]
  },
  {
    path: '/dms/permission',
    component: Layout,
    redirect: '/dms/permission/member',
    name: 'Permission',
    alwaysShow: true,
    meta: {
      title: '权限管理',
      icon: 'permission',
      permission_uri: '/dms/permission'
    },
    children: [{
      path: 'member',
      name: 'PermissionMember',
      component: () => import('@/views/dms/permission/member'),
      meta: {
        title: '成员管理',
        icon: 'user',
        permission_uri: '/dms/permission/member'
      }
    }]
  },
  {
    path: '/dms/outer',
    component: Layout,
    redirect: '/dms/outer/member',
    name: 'Outer',
    alwaysShow: true,
    meta: {
      title: '对外后台管理',
      icon: 'permission',
      permission_uri: '/dms/outer'
    },
    children: [{
      path: 'member',
      name: 'OuterMember',
      component: () => import('@/views/dms/outer/member'),
      meta: {
        title: '渠道后台管理',
        icon: 'user',
        permission_uri: '/dms/outer/member'
      }
    }, {
      path: 'overview',
      name: 'OutOverview',
      component: () => import('@/views/dms/outer/outOverview'),
      meta: {
        title: '对外数据分析',
        icon: 'overview',
        permission_uri: '/dms/outer/overview'
      }
    }, {
      path: 'site-config',
      name: 'SiteConfig',
      component: () => import('@/views/dms/outer/siteConfig'),
      meta: {
        title: '扣量/单价配置',
        icon: 'user',
        permission_uri: '/dms/outer/site-config'
      }
    }, {
      path: 'unsettlement',
      name: 'UnSettlement',
      component: () => import('@/views/dms/outer/unsettlement'),
      meta: {
        title: '未结算表',
        icon: 'comparison',
        permission_uri: '/dms/outer/unsettlement'
      }
    }, {
      path: 'settled',
      name: 'Settlement',
      component: () => import('@/views/dms/outer/settlement'),
      meta: {
        title: '已结算表',
        icon: 'comparison',
        permission_uri: '/dms/outer/settled'
      }
    }]
  }
  // 404 page must be placed at the end !!!
]
